<template>
    <div class="widget">
        <h4 class="widgettitle" style="margin-top: 20px;">{{ terms_translate }}</h4>
        <div class="background-white p20" style="min-height: 280px;">
            <div class="form-group">
                <div v-for="(term, index) in terms" class="checkbox termsCheckBox">
                    <input type="checkbox" :id="'term'+index+component_id" :value="term.slug"
                           v-model="selected_terms" @change="emitEvent" style="display: none;">
                    <label :for="'term'+index+component_id">{{ term.name }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import search from "../search";

export default {
    mixins: [
        search
    ],

    props: {
        terms_translate: {
            type: String,
            default: 'Main Categories'
        },
        auto_complete_route: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            component_id: 0,
            terms: [],
            selected_terms: [],
        }
    },

    methods: {
        getCategories() {
            let self = this;

            axios.get(`${this.auto_complete_route}?requested_type=categories`)
                .then(function (response) {
                    self.terms = response.data.results;
                })
                .catch(function () {
                    // Do nothing
                });
        },
        setSearchedTerms() {
            let terms = this.getUserSearchSessionByType('terms');

            if (terms.length > 0) {
                this.selected_terms = terms.map(term => term.value);
                this.emitEvent();
            }
        },
        emitEvent() {
            this.eventHub.$emit('term-ticked', this.selected_terms);
        }
    },

    created() {
        let self = this;

        this.eventHub.$on('reset_term', term => {
            self.selected_terms = self.selected_terms.filter(selected_term => selected_term !== term.value);
            self.emitEvent();
        });
    },

    mounted() {
        this.component_id = this._uid;

        this.getCategories();
        this.setSearchedTerms();
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/SearchTerms.vue